import queryString from 'query-string'
import { useMemo } from 'react'
import { CampaignSurveyLoaderProps } from '../components/campaign/CampaignSurveyLoader'

/**
 * Get relevant survey info from url and localstorage
 */
export function useSurveyProps(): CampaignSurveyLoaderProps {
  return useMemo(() => {
    // Get survey id from path
    const pathVariables = window.location.pathname.split('/').filter(Boolean)
    const surveyId = pathVariables[pathVariables.length - 1]

    // Get invitation id and source from query string
    const { i, m, source, sourceUrl, ...queryParams } = queryString.parse(location.search)

    // Get custom params from query string
    const regex = '^[p][0-9]+$'
    const customParams = Object.keys(queryParams).reduce<Record<string, string>>((params, key) => {
      const value = queryParams[key]
      if (!value) return params
      if (RegExp(regex).exec(key)) params[key] = Array.isArray(value) ? value.join(',') : value
      return params
    }, {})

    // Get answer id from localstorage, use try/catch because some browsers don't allow localstorage access
    let answerId: string | undefined
    try {
      answerId = localStorage.getItem(`${surveyId}_answerId`) || undefined
    } catch {
      answerId = undefined
    }

    return {
      surveyId,
      invitationId: typeof i === 'string' ? i : undefined,
      source: typeof source === 'string' ? source : undefined,
      sourceUrl: typeof sourceUrl === 'string' ? sourceUrl : undefined,
      customParams,
      answerId,
      mainSegmentIds: typeof m === 'string' ? m.split(',') : undefined,
    }
  }, [])
}
